import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Strategies from "./pages/Strategies";
import VenueIntelligence from "./pages/VenueIntelligence";
import HussarLab from "./pages/HussarLab";
import LearningReport from "./pages/LearningReport";
import IntelligenceArena from "./pages/IntelligenceArena";
import Assurance from "./pages/Assurance";
import Custody from "./pages/Custody";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Portfolio from "@/pages/Portfolio";
import Deploy from "@/pages/Deploy";
import Cash from "@/pages/Cash";
import Crypto from "@/pages/Crypto";
import Traditional from "@/pages/Traditional";
import YieldPage from "@/pages/Yield";
import Opportunities from "@/pages/Opportunities";
import Wildcard from "@/pages/Wildcard";
import Intelligence from "@/pages/Intelligence";
import CommandCenter from "@/pages/CommandCenter";
import TaxLedger from "@/pages/TaxLedger";
import TaxLots from "@/pages/TaxLots";
import Transactions from "@/pages/Transactions";
import Journal from "@/pages/Journal";
import Audit from "@/pages/Audit";
import Risk from "@/pages/Risk";
import Performance from "@/pages/Performance";
import Connections from "@/pages/Connections";
import Settings from "@/pages/Settings";
import RequestAccess from "@/pages/enterprise/RequestAccess";
import InviteAccept from "@/pages/enterprise/InviteAccept";
import EnterpriseDashboard from "@/pages/enterprise/EnterpriseDashboard";
import EnterpriseAdmin from "@/pages/enterprise/EnterpriseAdmin";

const ENTERPRISE_ROLES = ["enterprise_admin", "enterprise_member", "auditor"];

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return <div className="min-h-screen bg-[#0B0C0E] flex items-center justify-center text-slate-500 font-mono text-sm" data-testid="auth-loading">AUTHENTICATING…</div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (ENTERPRISE_ROLES.includes(user.role) && !location.pathname.startsWith("/enterprise")) {
    return <Navigate to="/enterprise" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="bottom-right" theme="dark" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/enterprise/request-access" element={<RequestAccess />} />
          <Route path="/enterprise/invite/:token" element={<InviteAccept />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/enterprise" element={<EnterpriseDashboard />} />
            <Route path="/enterprise/admin" element={<EnterpriseAdmin />} />
            <Route path="/" element={<Overview />} />
            <Route path="/command-center" element={<CommandCenter />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/deploy" element={<Deploy />} />
            <Route path="/strategies" element={<Strategies />} />
            <Route path="/venue-intelligence" element={<VenueIntelligence />} />
            <Route path="/lab" element={<HussarLab />} />
            <Route path="/lab/learning" element={<LearningReport />} />
            <Route path="/arena" element={<IntelligenceArena />} />
            <Route path="/assurance" element={<Assurance />} />
            <Route path="/custody" element={<Custody />} />
            <Route path="/cash" element={<Cash />} />
            <Route path="/crypto" element={<Crypto />} />
            <Route path="/traditional" element={<Traditional />} />
            <Route path="/yield" element={<YieldPage />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/wildcard" element={<Wildcard />} />
            <Route path="/intelligence" element={<Intelligence />} />
            <Route path="/tax-ledger" element={<TaxLedger />} />
            <Route path="/tax-lots" element={<TaxLots />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/risk" element={<Risk />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/connections" element={<Connections />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
